import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';
import { GetDocumentationByCategoryResponse, SyncWithConfluenceResponse } from '../interfaces/documentation.interface';

const BASE_URL = `${import.meta.env.VITE_BACKEND_URL}/api/documentation`;

export const apiDocumentation = createApi({
  reducerPath: 'apiDocumentation',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl: BASE_URL }),
  tagTypes: ['documentations', 'documentationsPageNames'],
  endpoints: (build) => ({
    getDocumentationPageNames: build.query<string[], void>({
      query: () => ({
        url: '/pageNames',
        method: 'GET'
      }),
      providesTags: ['documentationsPageNames']
    }),
    getDocumentationByCategory: build.query<GetDocumentationByCategoryResponse, { page: string; token?: string }>({
      query: ({ page, token }) => ({
        url: token ? `/pages/public/PreQA` : `/pages/${page}`,
        ...(token ? { params: { token } } : {}),
        method: 'GET'
      }),
      providesTags: ['documentations']
    }),
    getPublicToken: build.query<string, void>({
      query: () => ({
        url: '/publicToken',
        method: 'GET'
      })
    }),
    syncWithConfluence: build.mutation<SyncWithConfluenceResponse, void>({
      query: () => ({
        url: '/syncWithConfluence',
        method: 'POST'
      }),
      invalidatesTags: ['documentations', 'documentationsPageNames']
    })
  })
});

export const {
  useGetDocumentationPageNamesQuery,
  useGetDocumentationByCategoryQuery,
  useSyncWithConfluenceMutation,
  useGetPublicTokenQuery
} = apiDocumentation;
